window.PHKnowledge = [
  {
    id: "acqua-di-gio",
    name: "Acqua Di Gio",
    gender: "caballero",
    family: ["fresco", "acuatico", "citrico"],
    dna: ["limpio", "playero", "versatil"],
    occasions: ["diario", "playa", "oficina"],
    intensity: "media",
    climate: ["calor", "templado"],
    mood: ["relajado", "seguro", "natural"],
    score: 90
  },
  {
    id: "bleu-de-chanel",
    name: "Bleu de Chanel",
    gender: "caballero",
    family: ["fresco", "amaderado", "aromatico"],
    dna: ["elegante", "versatil", "moderno"],
    occasions: ["cita", "oficina", "elegante", "noche"],
    intensity: "media-alta",
    climate: ["templado", "frio"],
    mood: ["seguro", "formal", "atractivo"],
    score: 95
  },
  {
    id: "sauvage",
    name: "Sauvage",
    gender: "caballero",
    family: ["fresco", "especiado", "ambarado"],
    dna: ["masivo", "seductor", "potente"],
    occasions: ["cita", "noche", "diario"],
    intensity: "alta",
    climate: ["templado", "frio"],
    mood: ["seguro", "intenso", "dominante"],
    score: 92
  },
  {
    id: "invictus",
    name: "Invictus",
    gender: "caballero",
    family: ["fresco", "dulce", "acuatico"],
    dna: ["juvenil", "fiestero", "llamativo"],
    occasions: ["diario", "cita", "noche"],
    intensity: "media-alta",
    climate: ["calor", "templado"],
    mood: ["energetico", "coqueto", "casual"],
    score: 88
  },
  {
    id: "eros",
    name: "Eros",
    gender: "caballero",
    family: ["dulce", "aromatico", "vainilla"],
    dna: ["seductor", "nocturno", "intenso"],
    occasions: ["cita", "noche"],
    intensity: "alta",
    climate: ["frio", "templado"],
    mood: ["atractivo", "atrevido", "fiestero"],
    score: 91
  },
  {
    id: "one-million",
    name: "One Million",
    gender: "caballero",
    family: ["dulce", "especiado", "cuero"],
    dna: ["llamativo", "fiestero", "seductor"],
    occasions: ["cita", "noche"],
    intensity: "alta",
    climate: ["frio", "templado"],
    mood: ["extrovertido", "seguro", "atrevido"],
    score: 87
  },
  {
    id: "la-vie-est-belle",
    name: "La Vie Est Belle",
    gender: "dama",
    family: ["dulce", "floral", "vainilla"],
    dna: ["femenino", "elegante", "dulce"],
    occasions: ["cita", "elegante", "noche"],
    intensity: "alta",
    climate: ["frio", "templado"],
    mood: ["romantica", "segura", "sofisticada"],
    score: 94
  },
  {
    id: "good-girl",
    name: "Good Girl",
    gender: "dama",
    family: ["dulce", "floral", "ambarado"],
    dna: ["seductor", "elegante", "nocturno"],
    occasions: ["cita", "noche", "elegante"],
    intensity: "alta",
    climate: ["frio", "templado"],
    mood: ["atractiva", "segura", "misteriosa"],
    score: 95
  },
  {
    id: "chance",
    name: "Chance",
    gender: "dama",
    family: ["floral", "fresco", "almizclado"],
    dna: ["femenino", "limpio", "versatil"],
    occasions: ["diario", "oficina", "cita"],
    intensity: "media",
    climate: ["calor", "templado"],
    mood: ["natural", "fresca", "elegante"],
    score: 90
  },
  {
    id: "light-blue",
    name: "Light Blue",
    gender: "dama",
    family: ["citrico", "fresco", "frutal"],
    dna: ["veraniego", "limpio", "casual"],
    occasions: ["diario", "playa", "oficina"],
    intensity: "media",
    climate: ["calor"],
    mood: ["fresca", "relajada", "natural"],
    score: 88
  }
];